// Utility functions for debugging - localhost only

// Only enable debug logging on localhost
const isLocalhost = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || 
   window.location.hostname === '127.0.0.1' || 
   window.location.hostname === '0.0.0.0');

/**
 * Get environment variables from all possible sources
 */
export function getEnvironmentVariables() {
  return {
    // Primary environment variables
    VITE_CHAT_WS_URL: import.meta.env.VITE_CHAT_WS_URL || '',
    VITE_CHAT_API_URL: import.meta.env.VITE_CHAT_API_URL || '',
    
    // Vite environment information
    NODE_ENV: import.meta.env.NODE_ENV,
    MODE: import.meta.env.MODE,
    DEV: import.meta.env.DEV,
    PROD: import.meta.env.PROD,
  };
}

/**
 * Log environment variables and other useful debugging information
 * Only logs on localhost
 */
export function logDebugInfo() {
  if (!isLocalhost) {
    console.log('Debug info only available on localhost');
    return;
  }

  // Log environment variables
  console.group('Environment Variables:');
  const envVars = getEnvironmentVariables();
  Object.entries(envVars).forEach(([key, value]) => {
    console.log(`${key}:`, value);
  });
  console.groupEnd();

  // Log location info
  console.group('Location Information:');
  console.log('protocol:', window.location.protocol);
  console.log('host:', window.location.host);
  console.log('hostname:', window.location.hostname);
  console.log('origin:', window.location.origin);
  console.groupEnd();
  
  // Log proxy information
  console.group('Proxy Information:');
  console.log('Using WebSocket URL:', import.meta.env.VITE_CHAT_WS_URL);
  console.log('WebSocket URL is proxied in development mode via Vite');
  console.log('Target backend is dev.vrticmoj.com');
  console.groupEnd();
}

export default { logDebugInfo, getEnvironmentVariables }; 